import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Card,
  CardBody,
  Progress,
  Form,
  FormGroup,
  Label,
  Input,
  FormText
} from "reactstrap";
import NotificationSystem from "react-notification-system";
//react-redux comm
import { connect } from "react-redux";
import { appHelpers, store } from "../../_helpers";
import SearchPanel from "./search_panel";

// styling
import "./style.css";

import {
  alertActions,
  apiActions,
  commonActions,
  modalActions
} from "../../_actions";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";

import { commonService } from "../../_services";
import { alertConstants, appConstants } from "../../_constants";
import PaginatedResult from "./record";
import AddIcon from "react-icons/lib/md/library-add";
import SelectListComponent from "../utils/selectList";

const ViewHeader = () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">Ticket Class Setup</h1>
      <p className="mb-0 subtitle text-nowrap">Setup page for ticket class</p>
    </header>
  </div>
);

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class TicketClassSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      airlines: [],
      ticketClass: [],
      ticketCategory: [],
      selectedAirline: false,
      selectedTicket: false,
      selectedCategory: false,
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      records: false,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      modal: false,
      modalClass: "",
      saveAirlineName: "",
      ticketClassName: "",
      categoryName: "",
      recordId: false,
      saveTicketSetupEntityTypeId: null,
      editTicketSetupEntityTypeId: null,
      headerName: " ",
      contentErrorText: false,
      // airlineId: null,
      // categoryId: null,
      ticketClassId: null
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { airlines, ticketClass, ticketCategory, entities } = reduxState;
    const { dispatch } = this.props;

    if (airlines) {
      this.setState({ airlines: airlines.Results });
    } else {
      this.fetchAirlines();
    }

    if (ticketClass) {
      this.setState({ ticketClass: ticketClass.Results });
    } else {
      this.getTicketClass();
    }

    if (ticketCategory) {
      this.setState({ ticketCategory: ticketCategory.Results });
    } else {
      this.getTicketCategory();
    }

    /*Check if entity type exist in store */
    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }

    this.search(null, "initial");
  }

  componentWillReceiveProps(nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }

    if (entities) {
      this.setEntityTypes(entities);
    }
  }

  setEntityTypes = entities => {
    let saveTicketSetupEntityTypeId;
    let editTicketSetupEntityTypeId;

    entities.forEach(entity => {
      if (entity.EntityType === appConstants.APP_ENTITIES.CREATE_TICKET_SETUP) {
        saveTicketSetupEntityTypeId = entity.EntityTypeId;
      } else if (
        entity.EntityType === appConstants.APP_ENTITIES.UPDATE_TICKET_SETUP
      ) {
        editTicketSetupEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({ saveTicketSetupEntityTypeId, editTicketSetupEntityTypeId });
  };

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch, airlines } = this.props;
    if (!airlines) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getAllAirlines())
      .then(() => {
        let { airlines } = this.props;
        this.setState({ airlines: airlines.Results });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  getTicketClass = () => {
    this.setState({ contentError: false });
    const { dispatch, ticketClass } = this.props;
    if (!ticketClass) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startFullPageRequest());
    }

    dispatch(commonActions.getTicketClass())
      .then(() => {
        let { ticketClass } = this.props;

        this.setState({ ticketClass: ticketClass.Results });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  getTicketCategory = () => {
    this.setState({ contentError: false });
    const { dispatch, ticketCategory } = this.props;
    if (!ticketCategory) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startFullPageRequest());
    }

    dispatch(commonActions.getTicketCategory())
      .then(() => {
        let { ticketCategory } = this.props;
        this.setState({ ticketCategory: ticketCategory.Results });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = notification => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  search = async (pageNumber, initial) => {
    const { dispatch } = this.props;
    const {
      selectedAirline,
      selectedTicket,
      selectedCategory,
      pageSize
    } = this.state;

    let fromIndex;

    let currentPage;

    if (pageNumber === undefined) {
      dispatch(apiActions.startFullPageRequest());
      fromIndex = 0;
      pageNumber = 1;
    } else {
      fromIndex = pageSize * (pageNumber - 1);
      dispatch(apiActions.startRequest());
    }

    if (initial) {
      currentPage = 1;
      fromIndex = 0;
    } else {
      currentPage = pageNumber;
    }

    let payload__ = {
      PageSize: pageSize,
      From: fromIndex,
      Parameter: {}
    };

    if (selectedAirline) {
      payload__.Parameter.AirlineId = selectedAirline;
    }

    if (selectedCategory) {
      payload__.Parameter.CategoryId = selectedCategory;
    }

    if (selectedTicket) {
      payload__.Parameter.TicketClassId = selectedTicket;
    }

    commonService
      .searchTicketCategoryDetails(payload__)
      .then(res => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          const { TotalCount, Results } = res.response;
          this.setState({
            currentPage: currentPage,
            records: Results,
            totalCount: TotalCount
          });
          dispatch(apiActions.endRequest());
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(
            alertActions.error(
              appHelpers.interpretErrorResponseAlt2(res.response)
            )
          );
          dispatch(apiActions.endRequest());
        }
      })
      .catch(err => {
        dispatch(
          alertActions.error(appHelpers.interpretErrorResponseAlt2(err))
        );
        dispatch(apiActions.endRequest());
      });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleSelectChange = (payload, attribute, stateAttribute) => {
    let currState = this.state;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    currState[stateAttribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    this.setState(currState);
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      saveAirlineName: "",
      ticketClassName: "",
      categoryName: ""
    });
    this.resetError();
  }

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  toggle = (e, modalClass, headerName) => {
    this.setState({ headerName: headerName });
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.saveAirlineName === "") {
      _errs_["saveAirlineName"] = "Please select an airline";
      formValid = false;
    }

    if (this.state.ticketClassName === "") {
      _errs_["ticketClassName"] = "Please enter a ticket class";
      formValid = false;
    }

    if (this.state.categoryName === "") {
      _errs_["categoryName"] = "Please select a category";
      formValid = false;
    }
    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  processSubmit = () => {
    let {
      recordId,
      saveAirlineName,
      ticketClassId,
      categoryName,
    } = this.state;
    const userRole = appHelpers.getActiveUser().AviRole;

    let payload = {
      AirlineId: saveAirlineName,
      CategoryId: categoryName,
      TicketClassId: ticketClassId
    };
    if (recordId) {
      payload.Id = recordId;
    }

    if (userRole === appConstants.ROLES.VGG_ADMIN) {
      this.createMakerChecker(payload);
    } else {
      this.createTicketClass(payload);
    }
  };

  createTicketClass = payload => {
    const { dispatch } = this.props;

    dispatch(apiActions.startRequest());
    commonService.createTicketClass(payload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Ticket class updated successfully"
          : "Ticket class created successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });

  };

  createMakerChecker = payload => {
    const { dispatch } = this.props;
    const { authentication } = store.getState();

    let {
      recordId,
      saveAirlineName,
      ticketClassName,
      categoryName,
      saveTicketSetupEntityTypeId,
      editTicketSetupEntityTypeId
    } = this.state;

    /*Maker Checker */
    let payloadTemplate = {
      Airline: this.interpretAirline(saveAirlineName),
      Category: this.interpretCategory(categoryName),
      TicketClass: ticketClassName
    };

    // console.log({payloadTemplate})

    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${
        appConstants.PAS_URL
      }/api/TicketCategory/SaveTicketCategoryDetails`,
      EntityTypeId: saveTicketSetupEntityTypeId,
      CreatedBy: authentication.user.userName
    };

    // console.log({makerCheckerPayload});
    if (recordId) {
      makerCheckerPayload.EntityTypeId = editTicketSetupEntityTypeId;
    }

    dispatch(apiActions.startRequest());
    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = recordId
          ? "Ticket class update sent successfully"
          : "Ticket class creation sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  handleEdit = record => {
    // console.log({record})
    this.setState({
      recordId: record.Id,
      saveAirlineName: record.AirlineId ? record.AirlineId : "",
      categoryName: record.CategoryId ? record.CategoryId : "",
      ticketClassName: record.TicketName ? record.TicketName : "",
      ticketClassId: record.TicketId ? record.TicketId: ""
    });
    this.toggle(null, "modalSlideIn", "Update Ticket Class");
  };

  interpretAirline(airlineId) {
    const { Results } = this.props.airlines;
    if (Results) {
      const airlineName = Results.find(airline => airline.Id === airlineId);
      if (airlineName) return airlineName.Name;
    }
  }

  interpretCategory(categoryId) {
    const { ticketCategory } = this.state;
    if (ticketCategory) {
      const ticketCategoryName = ticketCategory.find(
        category => category.Id === categoryId
      );
      if (ticketCategoryName) return ticketCategoryName.Name;
    }
  }

  render() {
    let modalResponse = this.renderPageResponse();
    const {
      airlines,
      ticketClass,
      ticketCategory,
      selectedAirline,
      selectedTicket,
      selectedCategory,
      contentError,
      records,
      currentPage,
      pageSize,
      totalCount,
      componentErrorMessages,
      saveAirlineName,
      ticketClassName,
      categoryName,
      modalClass,
      headerName,
      contentErrorText
    } = this.state;

    const { requesting, pageRequesting } = this.props;
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={contentError} />}

            {/*Display component content when Data is gotten from API*/}

            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <div className="row">
                  <div className="mb-4 col-md-8 pull-left">
                    <h6 className="text-uppercase ">Search Panel</h6>
                    <SearchPanel
                      contentErrorText={contentErrorText}
                      airline={airlines}
                      ticketClass={ticketClass}
                      category={ticketCategory}
                      selectedAirline={selectedAirline}
                      selectedTicket={selectedTicket}
                      selectedCategory={selectedCategory}
                      onAirlineChange={payload =>
                        this.handleSelectChange(
                          payload,
                          "Id",
                          "selectedAirline"
                        )
                      }
                      onTicketChange={payload =>
                        this.handleSelectChange(payload, "Name", "selectedTicket")
                      }
                      onCategoryChange={payload =>
                        this.handleSelectChange(
                          payload,
                          "Id",
                          "selectedCategory"
                        )
                      }
                      onSearch={this.search}
                    />
                  </div>

                  <div className="mb-4 col-md-4 text-right">
                    <Button
                      className="btn-avi-primary"
                      onClick={e =>
                        this.toggle(e, "modalSlideIn", "Add Ticket Class")
                      }
                    >
                      <AddIcon color="#ffffff" size="18" />
                      &nbsp;Create Ticket Class
                    </Button>{" "}
                  </div>
                </div>

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={modalClass}
                >
                  <ModalHeader toggle={this.toggle}>{headerName}</ModalHeader>
                  <Form onSubmit={this.handleSubmit}>
                    <ModalBody>
                      {modalResponse}

                      <FormGroup
                        className={
                          "mb-4 " +
                          (componentErrorMessages.saveAirlineName
                            ? "has-danger"
                            : "")
                        }
                      >
                        <Label>Airline Name</Label>
                        <SelectListComponent
                          data={airlines}
                          valueKey="Id"
                          textField="Name"
                          selectValue={saveAirlineName}
                          onValueChange={payload =>
                            this.handleSelectChange(
                              payload,
                              "Id",
                              "saveAirlineName"
                            )
                          }
                        />
                        {/*<Input type="text" placeholder="" value={saveAirlineName} onChange={(event) => this.handleChange(event, 'saveAirlineName')} />*/}
                        {componentErrorMessages.saveAirlineName && (
                          <FormText color="danger">
                            {" "}
                            {componentErrorMessages.saveAirlineName}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup
                        className={
                          "mb-4 " +
                          (componentErrorMessages.ticketClassName
                            ? "has-danger"
                            : "")
                        }
                      >
                        <Label>Ticket Class</Label>
                        <Input
                          type="text"
                          placeholder=""
                          value={ticketClassName}
                          onChange={event =>
                            this.handleChange(event, "ticketClassName")
                          }
                        />
                        {componentErrorMessages.ticketClassName && (
                          <FormText color="danger">
                            {" "}
                            {componentErrorMessages.ticketClassName}
                          </FormText>
                        )}
                      </FormGroup>
                      <FormGroup
                        className={
                          "mb-4 " +
                          (componentErrorMessages.categoryName
                            ? "has-danger"
                            : "")
                        }
                      >
                        <Label>Category</Label>
                        <SelectListComponent
                          data={ticketCategory}
                          valueKey="Id"
                          textField="Name"
                          selectValue={categoryName}
                          onValueChange={payload =>
                            this.handleSelectChange(
                              payload,
                              "Id",
                              "categoryName"
                            )
                          }
                        />
                        {/*<Input type="text" placeholder="" value={categoryName} onChange={(event) => this.handleChange(event, 'categoryName')} />*/}
                        {componentErrorMessages.categoryName && (
                          <FormText color="danger">
                            {" "}
                            {componentErrorMessages.categoryName}
                          </FormText>
                        )}
                      </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn-avi-primary" disabled={requesting}>
                        {" "}
                        Proceed{" "}
                      </Button>{" "}
                      <Button color="secondary" onClick={this.toggle}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Form>
                  {requesting && <div className={"loading-dot active"} />}
                </Modal>

                <CardBody>
                  {!pageRequesting && records && (
                    <div>
                      <PaginatedResult
                        records={records}
                        currentPage={currentPage}
                        navigate={this.search}
                        pageSize={pageSize}
                        totalCount={totalCount}
                        handleEdit={this.handleEdit}
                      />
                    </div>
                  )}
                  {!pageRequesting && !records && (
                    <PageEmptyContent message="No record match your search!" />
                  )}
                </CardBody>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const {
    modal,
    alert,
    airlines,
    entities,
    ticketClass,
    ticketCategory
  } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    airlines,
    entities,
    ticketClass,
    ticketCategory
  };
}

export default connect(mapStateToProps)(TicketClassSetup);

/* Written with love by Juliet July 2019 */



// WEBPACK FOOTER //
// ./src/views/ticket-class-setup/index.js